<template>
    <div>
        <ModalComponent
            name="cambiar-talla"
            :title="'Cambiar talla de la indumentaria ' + indumentaria.nombre"
            v-on:close="() => close()"
            v-if="!loading"
        >
            <h4 class="pb-4 text-center">Cambiar talla de la indumentaria: {{ indumentaria.nombre }}</h4>
            <b-row>
                <b-col cols="6" class="mb-3">
                    <label for="talla">Tallas</label>
                    <ValidationProvider v-if="tallas" name="talla" id="talla">
                        <multiselect 
                            v-model="tallaSelect"
                            id="talla"
                            placeholder="Tallas"
                            class="mr-1"
                            label="nombre"
                            track-by="id"
                            :options="tallas"
                            @select="getStock"
                            :max-height="130"
                            :show-labels="false"
                        />
                    </ValidationProvider>
                </b-col>
                <b-col cols="6">
                    <label for="stock">Stock</label>
                    <ValidationProvider v-if="stockDisponible" name="stock" id="stock">
                        <multiselect 
                            v-model="stockSelect"
                            id="stock"
                            placeholder="Ud"
                            :options="stockDisponible"
                            :max-height="130"
                            :show-labels="false"
                        >
                            <template slot="noOptions">No hay unidades disponibles.</template>
                        </multiselect>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <b-btn :disabled="!stockSelect && !indumentaria.tallaSelect" @click="editarTalla()">Continuar</b-btn>
        </ModalComponent>
        <LoaderComponent v-else/>
    </div>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['indumentaria'],
        data() {
            return {
                loading: false,
                stockDisponible: [],
                stock: null,
                tallas: null,
                stockSelect: null,
                tallaSelect: null
            }
        },
        methods: {
            close() {                
                this.$emit('close', 'cambiar-talla');
            },
            editarTalla() {
                this.indumentaria.stockSelect = this.stockSelect;
                this.$emit('talla-cambiada');
                this.close();
            },
            getStock(talla) {
                let params = {
                    lista_id: this.lista_id,
                    indumentaria_id: this.indumentaria.indumentaria_id,
                    talla_id: talla.id,
                    filters: {
                        base_id: this.$route.params.base_id
                    }
                }
                this.$store.dispatch(this.config.getVuexAlias('back.bases.indumentarias.get-stock-talla'), params).then(res => {
                    this.stock = res.data.stock;
                });
            
                setTimeout(() => {
                    var cantidad = this.stock <= this.indumentaria.pivot.cantidad ? this.stock : this.indumentaria.pivot.cantidad;

                    this.stockDisponible = [];
                    for (var i = 1; i <= cantidad; i++) {
                        this.stockDisponible.push(i);
                    }
                }, 400);

                this.stockSelect = null;

                this.indumentaria.tallaSelect = talla;
                this.indumentaria.tallaSelect.base_indumentaria_id = this.indumentaria.id;
            },
            getTallas() {
                let params = {
                    lista_id: this.lista_id,
                    indumentaria_id: this.indumentaria.indumentaria_id,
                    filters: {}
                }
                this.$store.dispatch(this.config.getVuexAlias('back.bases.indumentarias.get-tallas-indumentaria'), params).then(res => {
                    this.tallas = res.data.tallas;
                    this.tallas.splice(this.tallas.findIndex(talla => talla.id === this.indumentaria.pivot.talla_id), 1);
                });
            }
        },
        computed: {
            lista_id() {
                return this.$route.params.lista_id;
            } 
        },
        created() {
            this.getTallas();
        },
        components: {
            ModalComponent
        }
    }
</script>
<!--  -->